<template>
  <section class="helper_6">
    <div class="helper_title_6">
      <h4>出行助手</h4>
    </div>

    <ul class="helper_box_6">
      <li
        class="helper_item_6 map_bg_6"
        bg-url="@/plan/assets/image/6/map.jpg"
        v-bg
      >
        <div class="item_box_6">
          <h6>Flyme Map UI Demo</h6>
          <p>轻松快速上车<br />完整地图导航服务</p>
        </div>
      </li>

      <li
        class="helper_item_6 core_bg_6"
        bg-url="@/plan/assets/image/6/sdk.jpg"
        v-bg
      >
        <div class="item_box_6">
          <h6>Flyme Map Core SDK</h6>
          <p>灵活定制 HMI<br />降低研发接入门槛</p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Help',

  data() {
    return {}
  },

  methods: {
    onLaunch() {},
  },
}
</script>

<style lang="less" scoped>
.helper_6 {
  background-color: #f7f8fa;
}

.helper_title_6 {
  width: 1200px;
  padding: 100px 0 50px 0;
  margin: auto;

  h4 {
    font-weight: 700;
    font-size: 46px;
    line-height: 65px;
    background: linear-gradient(85.31deg, #32b5ff -1.29%, #237dff 99.49%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
}

.helper_box_6 {
  margin: auto;
  width: 1200px;
}

.helper_item_6 {
  width: 100%;
  height: 624px;
  border-radius: 24px;
  background-color: #fff;
  position: relative;
  overflow: hidden;

  .item_box_6 {
    position: absolute;
    top: 190px;
    left: 120px;
    width: 461px;
    z-index: 1;
  }

  h6 {
    font-weight: 700;
    font-size: 24px;
    line-height: 34px;
    margin: 0;

    background: linear-gradient(85.31deg, #32b5ff -1.29%, #237dff 99.49%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }

  p {
    font-weight: 700;
    font-size: 46px;
    line-height: 65px;
    margin: 0;
    color: #000000;
  }

  &.map_bg_6 {
    background-size: 100% 100%;
  }

  &.core_bg_6 {
    margin-top: 20px;
    background-size: 360px 466px;
    background-position: 686px 84px;
    background-repeat: no-repeat;
  }
}
</style>
